import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class BrandItemPopupService {
  private triggerSource = new Subject<any>();
  trigger$ = this.triggerSource.asObservable();

  trigger(data?: any) {
    this.triggerSource.next(data);
  }
}